export const UNCATEGORIZED_ID = 'uncategorized';
export const FAVORITES_ID = 'favorites';

export const getMacroEntryId = (macroId: string, scopeId?: string) =>
  scopeId ? `macro-${scopeId}-${macroId}` : `macro-${macroId}`;

export const getFolderEntryId = (folderId: string) => `folder-${folderId}`;
